export const fenToYuan = (money, tofixed) => {
    if (!money) return money;
    money = (money*0.01).toFixed(2);
    if (tofixed == 2) {
        return money;
    }
    return (/.00/.test(money)) ? parseInt(money) : money;
}